import React, { useState } from "react";

import "./stylesNewDropdown.css";
import { ChevronDown, ChevronUp } from "react-feather";

const NewDropdown = ({ options, selectedValue, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const option = options.find((option) => option.value === selectedValue);
  console.log(options, selectedValue);

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" onClick={() => setIsOpen(!isOpen)}>
      <div className="dropdown-selected">
        {option.label ? (
          <div className="dropdown-selected-item">
            <span className={`dropdown-circle-${option.value}`}></span>
            {option.label}
          </div>
        ) : (
          "Select"
        )}
      </div>

      <div className="dropdown-icon-container">
        {isOpen ? (
          <ChevronUp className="dropdown-icon" />
        ) : (
          <ChevronDown className="dropdown-icon" />
        )}
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          {options.map((option) => (
            <li
              key={option.value}
              className="dropdown-item"
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NewDropdown;
